










import { Component, Vue } from 'vue-property-decorator'
import PeriodEditor from './components/PeriodEditor.vue'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    PeriodEditor,
  },
})
export default class EditPeriod extends Vue {
  private canLeave = true

  private created(): void {
    this.$route.meta.refresh = false
  }

  private beforeRouteLeave(to, from, next): void {
    if (!this.$store.state.forceBack) {
      if (!this.canLeave) {
        this.$confirm({
          title: this.$t('common.unsaveConfirm'),
          onOk: () => {
            next()
          },
          onCancel: () => {
            next(false)
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }
}
